import { render, staticRenderFns } from "./TableButtonGroup.vue?vue&type=template&id=871eee80&scoped=true"
import script from "./TableButtonGroup.vue?vue&type=script&lang=js"
export * from "./TableButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./TableButtonGroup.vue?vue&type=style&index=0&id=871eee80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871eee80",
  null
  
)

export default component.exports